import {Col, DatePicker, Form, Input, InputNumber, Row, Select} from 'antd';
import React, {useContext, useEffect} from 'react';
import AddFormComponent from '../common/AddFormComponent';
import EditFormComponent from '../common/EditFormComponent';
import {Arguments} from '../common/Arguments';
import SaveButtonComponent from '../common/SaveButtonComponent';
import {validateEditorContent, validateWhiteSpace} from '../common/ValidateWhiteSpace';
import WangEditor from '../common/WangEditor';
import {sideMenuContext} from '../../../router/IndexRouter';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const formRef = React.createRef();

const AddBranchActivity = () => {
	// 获取 WangEditor 中的内容
	const {editorContent} = useContext(sideMenuContext);
	const currentUrl = window.location.href;
	const apiList = [Arguments.host + '/society_organization/base/branch/api!addBranchActivity.do'];

	useEffect(() => {
		formRef.current.setFieldsValue({
			activityMemo: editorContent,
		});
	}, [editorContent]);

	return (currentUrl.endsWith('add') ? <AddFormComponent UserForm={BranchActivityForm} url={apiList}/> :
		<EditFormComponent UserForm={BranchActivityForm} url={apiList}/>);
};

const BranchActivityForm = ({onFinish, initialValues}) => {
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={onFinish}
			initialValues={initialValues}
			style={{maxWidth: 1200, marginLeft: 40}}
			ref={formRef}
		>
			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activityName" label="活动主题" rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item
						name="activityDate"
						label="活动时间"
						rules={[{required: true}]}
					>
						<DatePicker placeholder="选择日期"/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="activityScope" label="参加人数" rules={[{required: true, message: '内容不能为空'}]}
							   initialValue={0}>
						<InputNumber style={{width: 150}} min={0}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activityAddress" label="活动地址"
						rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activityForm" label="活动类别" rules={[{required: true, message: '内容不能为空'}]}
						initialValue="支部会">
						<Select>
							<Select.Option value="支部会">支部会</Select.Option>
							<Select.Option value="支部党员大会">支部党员大会</Select.Option>
							<Select.Option value="党小组会">党小组会</Select.Option>
							<Select.Option value="专题组织生活会">专题组织生活会</Select.Option>
							<Select.Option value="党课学习">党课学习</Select.Option>
							<Select.Option value="主题党日">主题党日</Select.Option>
							<Select.Option value="其他">其他</Select.Option>
						</Select>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activityMemo" label="活动说明"
						rules={[{required: true, validator: validateEditorContent}]}
					>
						<WangEditor
							defaultValue={initialValues?.activityMemo}
							placehoderText="请在此填写活动内容！活动结束后请上传活动现场照片以及相应文字材料！"
						/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<SaveButtonComponent/>
			</Form.Item>
		</Form>
	);
};

export default AddBranchActivity;

